module.exports = __webpack_public_path__ + "static/media/JinRong1.60d3dc8b.png";